module.exports = __webpack_public_path__ + "img/amelie-les-bains.d547e922.jpg";